// NOTE: IMPORT OTHER CONSTANTS AND DEPENDENCIES
import Root from "../Layout/Root";
import { createBrowserRouter } from "react-router-dom";

// NOTE: IMPORT AUTH PAGES
// import SignIn from "../pages/Login/SignIn";
import SignIn from "../pages/Login/SignIn";
import ForgotPassword from "../pages/Login/ForgotPassword";
import SetNewPassword from "../pages/Login/SetNewPassword";

// NOTE: IMPORT COMMON PAGES
import ErrorPage from "../error/Error";
import ServerError from "../error/ServerError";

// NOTE: IMPORT HOOKS
import {
  ProtectedRoute,
  PublicRoute,
} from "../components/protectedAndPublicRoute";

// IMPORT NAVIGATION PAGES
import LoginLayout from "../Layout/LoginLayout";
import CreateUser from "../pages/CreateUser";
import AdminLayout from "../Layout/AdminLayout";
import ViewUsers from "../pages/ViewUsers";

const router = createBrowserRouter([
  // Auth Routes with LoginLayout
  {
    path: "/",
    element: <LoginLayout />,
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: <SignIn />,
      },
      {
        path: "",
        element: <PublicRoute />,
        children: [
          {
            path: "login",
            element: <SignIn />,
          },
          {
            path: "forgot-password",
            element: <ForgotPassword />,
          },
          {
            path: "set-new-password",
            element: <SetNewPassword />,
          },
        ],
      },
    ],
  },

  {
    path: "/admin",
    // element: <AdminLayout />,
    element: <ProtectedRoute />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "",
        element: <AdminLayout />,
        children: [
          {
            path: "users",
            element: <ViewUsers />,
          },
          {
            index: true,
            element: <ViewUsers />,
          },
          {
            path: "create-user",
            element: <CreateUser />,
          },
        ],
      },
    ],
  },
  // Standalone Routes
  {
    path: "create-user",
    element: <CreateUser />,
  },
  // Error Routes
  {
    path: "/server-error",
    element: <ServerError />,
    errorElement: <ErrorPage />,
  },
  {
    path: "*",
    element: <ErrorPage />,
  },
  {
    path: "create-user",
    element: <CreateUser />,
  },
]);

export default router;
